module.exports = __webpack_public_path__ + "img/DW_Ab1.e3e2abdb.png";